import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getCategoriasLista = async () => {
    const res = await getData('/categorias/categorias_select');
    return res
}

export const getCategoriasPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
  
    if (searchTerm) {
      queryParams.push(`categ_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
      queryParams.push(`page=${encodeURIComponent(page)}`);
    }
    if (perPage) {
      queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
    }
    const queryString = queryParams.length > 0 ? `?}&${queryParams.join('&')}` : '';
  
    return await getData("/categorias", queryString);
  };

export const getCategoriaById = async (id) => {
    const res = await getData(`/categorias/${id}`)
    return res
}

export const postCategoria = async (body) => {
    const res = await postData('/categorias', body)
    return res
}

export const patchCategoria = async (id, body) => {
    const res = await patchData(`/categorias/${id}`, body)
    return res
}

export const deleteCategoria = async (id) => {
    const res = await deleteData(`/categorias/${id}`)
    return res
}